import initialState from './initialState';
import * as types from '../actions/actionTypes';

export default (state = initialState.voucher, action) => {
  switch (action.type) {
    case types.SET_THIRD_PARTY_PRODUCT:
      return action.voucher;

    default:
      return state;
  }
};
